<template>
  <!-- 라이브 분석 패널 (dev 전용). 채팅 피드 왼쪽. 렌즈 A(빈도)·C(soynlp) 랭크. -->
  <div class="analysis-panel d-flex flex-column">
    <div class="analysis-panel__head d-flex align-center">
      <v-icon size="16" color="#7cf" class="mr-1">mdi-chart-box-outline</v-icon>
      <span class="analysis-panel__title">라이브 분석</span>
      <v-spacer></v-spacer>
      <span class="analysis-panel__meta">{{ analysis.count || 0 }}문장 · {{ agoText }}</span>
    </div>

    <div class="analysis-panel__body flex-grow-1">
      <!-- A. 형태소 빈도 -->
      <div class="lens">
        <div class="lens__title">A · 형태소 빈도</div>
        <div v-if="!analysis.A || !analysis.A.length" class="lens__empty">분석 대기…</div>
        <div v-for="it in analysis.A" :key="'a' + it.rank" class="lens__row">
          <span class="lens__rank">{{ it.rank }}</span>
          <span class="lens__term">{{ it.term }}</span>
          <span class="lens__val">{{ it.count }}</span>
        </div>
      </div>

      <!-- C. soynlp 비지도 단어 -->
      <div class="lens">
        <div class="lens__title">C · soynlp 발견 단어</div>
        <div v-if="!analysis.C || !analysis.C.length" class="lens__empty">분석 대기…</div>
        <div v-for="it in analysis.C" :key="'c' + it.rank" class="lens__row">
          <span class="lens__rank">{{ it.rank }}</span>
          <span class="lens__term">{{ it.word }}</span>
          <span class="lens__val">{{ it.cohesion }}</span>
        </div>
      </div>

      <!-- D. krwordrank 키워드 -->
      <div class="lens">
        <div class="lens__title">D · krwordrank 키워드</div>
        <div v-if="!analysis.D || !analysis.D.length" class="lens__empty">분석 대기…</div>
        <div v-for="it in analysis.D" :key="'d' + it.rank" class="lens__row">
          <span class="lens__rank">{{ it.rank }}</span>
          <span class="lens__term">{{ it.word }}</span>
          <span class="lens__val">{{ it.score }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AnalysisPanel",
  props: {
    // { A: [{rank, term, count}], C: [{rank, word, cohesion}], D: [{rank, word, score}], count }
    analysis: { type: Object, default: () => ({ A: [], C: [], D: [], count: 0 }) },
    updatedAt: { type: Number, default: 0 }, // 마지막 갱신 시각(ms). 경과시간 표시용.
  },
  data() {
    return { now: Date.now() };
  },
  computed: {
    agoText() {
      if (!this.updatedAt) return "대기 중";
      const s = Math.max(0, Math.floor((this.now - this.updatedAt) / 1000));
      if (s < 1) return "방금";
      if (s < 60) return `${s}초 전`;
      return `${Math.floor(s / 60)}분 전`;
    },
  },
  mounted() {
    // 매초 경과시간 갱신
    this.tick = setInterval(() => {
      this.now = Date.now();
    }, 1000);
  },
  beforeDestroy() {
    if (this.tick) clearInterval(this.tick);
  },
};
</script>

<style scoped>
.analysis-panel {
  position: fixed;
  top: 0;
  right: 320px; /* 채팅 피드(width 320) 왼쪽 */
  width: 260px;
  height: 100vh;
  background: rgba(16, 18, 28, 0.92);
  color: #dfe6ff;
  z-index: 20;
  border-left: 1px solid rgba(124, 200, 255, 0.22);
  font-size: 12px;
}
.analysis-panel__head {
  padding: 8px 10px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  flex: 0 0 auto;
}
.analysis-panel__title {
  font-weight: 700;
  letter-spacing: 0.02em;
}
.analysis-panel__meta {
  color: #8aa0d0;
  font-size: 11px;
  font-variant-numeric: tabular-nums;
}
.analysis-panel__body {
  overflow-y: auto;
  padding: 6px 8px;
}
.lens {
  margin-bottom: 14px;
}
.lens__title {
  font-size: 11px;
  font-weight: 700;
  color: #7cf;
  padding: 4px 2px 6px;
  position: sticky;
  top: 0;
  background: rgba(16, 18, 28, 0.96);
}
.lens__empty {
  color: #6a6f85;
  padding: 4px 2px;
}
.lens__row {
  display: flex;
  align-items: baseline;
  gap: 6px;
  padding: 2px 2px;
}
.lens__rank {
  flex: 0 0 18px;
  text-align: right;
  color: #6a7290;
  font-variant-numeric: tabular-nums;
}
.lens__term {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 600;
}
.lens__val {
  flex: 0 0 auto;
  color: #8aa0d0;
  font-variant-numeric: tabular-nums;
}
</style>
